import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { ds } from 'mewe/stores/ds';
import dispatcher from 'mewe/dispatcher';
import { installDropdown } from 'mewe/utils/dropdown-utils';

export default class MwEventParticipationSelector extends Component {
  @service router;
  @service dynamicDialogs;
  @service analytics;

  @tracked dropdownOptions;

  constructor() {
    super(...arguments);
    installDropdown(this, 'dropdownOptions');
  }

  get isOwner() {
    // situation in post event info rendered via WS
    if (this.args.isPostEventInfo) {
      return this.args.isCurrentUserPostOwner;
    } else {
      return this.args.eventData?.isOwner;
    }
  }

  get hideSelector() {
    return this.isOwner && (this.args.skin === 'post-event' || this.args.skin === 'event-popup');
  }

  get participationInfo() {
    const participationType = this.args.eventData?.participationType;
    let text, icon;

    if (this.args.eventData?.isPastEvent) {
      if (this.isOwner) {
        text = __('You hosted this');
        icon = 'tick-circle';
      } else if (participationType === 'Attending') {
        text = __('You attended this');
        icon = 'tick-circle';
      }
      else {
        text = __(`You didn't attend this`);
        icon = 'slash';
      }
    } else {
      if (this.isOwner) {
        text = __(`You're hosting this`);
        icon = 'tick-circle';
      } else if (participationType === 'Invited') {
        text = __(`You're invited`);
        icon = 'directbox-receive';
      } else if (participationType === 'Interested') {
        text = __(`You're interested`);
        icon = 'search-normal-1';
      } else if (participationType === 'Attending') {
        text = __(`You're going to this`);
        icon = 'tick-circle';
      } else if (participationType === 'NotAttending') {
        text = __(`You're not going to this`);
        icon = 'slash';
      } else {
        text = __(`Are you interested?`);
        icon = 'directbox-receive';
      }
    }

    return { text, icon };
  }

  @action
  stopPropagation(e) {
    // in case this component is in other, clickable, component (SG-35072) or link (SG-35088)
    e.stopPropagation();
    e.preventDefault();
  }

  @action
  setParticipation(type) {
    if (this.args.post?.isPublicContent && this.args.post?.customInteraction) {
      return;
    }

    const scopeId = this.args.eventData.groupId ?? 'events';

    const callback = () => {
      dispatcher.dispatch('events', 'getCounters', scopeId, () => {
        let counters = ds.eventsCounters[scopeId];
        if (counters?.invitations === 0 && this.args.skin === 'events-list') {
          if (!this.args.eventData.groupId) {
            this.router.transitionTo('app.events.upcoming');
          } else {
            this.router.transitionTo('app.group.calendar.upcoming');
          }
        }
      });
    };
    dispatcher.dispatch('events', 'setParticipation', this.args.eventData, type, callback);
  }
}
